import { signal } from "@angular/core";

export const isMirror = signal<boolean>(null);
